<template>
  <div class="admin-main-layout">
    <el-container>
      <el-aside width="width: 240px;" v-if="isvLeft" class="left-layout">
        <div class="system-title">后台管理系统</div>
        <div class="scrollbar-menu">
          <el-scrollbar style="height:100%;">
            <el-menu :default-active="activeMenu()" class="open-menu">
              <el-submenu  v-if="valid('API_MANAGE_DEVELOPER')" index="开发者管理">
                  <template slot="title">
                    <i class="el-icon-message"></i>
                    <span>开发者管理</span>
                    <!-- <router-link :to="{name: 'devmanage'}">开发者管理</router-link> -->
                  </template>
                  <router-link :to="{name: 'devmanage'}"><el-menu-item index="开发者管理"> <template> <i class="el-icon-menu"></i> 开发者管理</template></el-menu-item></router-link>
                  <router-link :to="{name: 'applyuser'}"><el-menu-item index="在线申请"><template> <i class="el-icon-menu"></i>在线申请</template></el-menu-item></router-link>
              </el-submenu>
              <el-submenu  v-if="valid('API_MANAGE_STATISTICS')" index="接口调用统计">
                <template slot="title">
                  <i class="el-icon-message"></i>
                  <span>接口调用统计</span>
                  <!-- <router-link :to="{name: 'istatistics'}">接口调用统计</router-link> -->
                </template>
                <router-link :to="{name: 'istatistics'}"><el-menu-item index="整体趋势"> <template> <i class="el-icon-menu"></i> 整体趋势</template></el-menu-item></router-link>
                <router-link :to="{name: 'istatisticsInterface'}"><el-menu-item index="按接口统计"><template> <i class="el-icon-menu"></i> 按接口统计</template></el-menu-item></router-link>
              </el-submenu>
              <el-submenu  v-if="valid('API_MANAGE_USER')" index="系统管理">
                <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>系统管理</span>
                  <!-- <router-link :to="{name: 'sysmanage'}">系统管理</router-link> -->
                </template>
                <router-link :to="{name: 'sysmanage'}">
                <el-menu-item index="用户管理"> <template> <i class="el-icon-menu"></i> 用户管理</template></el-menu-item>
                </router-link>
              </el-submenu>
              <el-submenu  v-if="valid('API_MANAGE_BASIC_DATA')" index="目录管理">
                <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>目录管理</span>
                </template>
                <router-link :to="{name: 'learnManage'}">
                  <el-menu-item index="学段管理">
                    <template slot="title"><i class="el-icon-menu"></i>学段管理</template>
                  </el-menu-item>
                </router-link>
                <router-link :to="{name: 'classManage'}">
                  <el-menu-item index="科目管理">
                    <template slot="title"><i class="el-icon-message"></i>科目管理</template>
                  </el-menu-item>
                </router-link>
                <!-- <router-link :to="{name: 'versionManage'}">
                  <el-menu-item index="版本管理">
                    <template slot="title"><i class="el-icon-message"></i>版本管理</template>
                  </el-menu-item>
                </router-link> -->
                <el-submenu index="版本管理">
                  <template slot="title">
                    <i class="el-icon-message"></i>
                    <span>版本管理</span>
                  </template>
                  <router-link :to="{name: 'versionManage'}">
                    <el-menu-item index="通用版本">
                      <template slot="title">通用版本</template>
                    </el-menu-item>
                  </router-link>
                  <router-link :to="{name: 'specialVersionManage'}">
                    <el-menu-item index="专用版本">
                      <template slot="title">专用版本</template>
                    </el-menu-item>
                  </router-link>
                </el-submenu>
                <!-- <router-link :to="{name: 'volumeManage'}">
                  <el-menu-item index="册别管理">
                    <template slot="title"><i class="el-icon-message"></i>册别管理</template>
                  </el-menu-item>
                </router-link> -->
                <el-submenu index="册别管理">
                  <template slot="title">
                    <i class="el-icon-message"></i>
                    <span>册别管理</span>
                  </template>
                  <router-link :to="{name: 'volumeManage'}">
                    <el-menu-item index="通用册别">
                      <template slot="title">通用册别</template>
                    </el-menu-item>
                  </router-link>
                  <router-link :to="{name: 'specialVolumeManage'}">
                    <el-menu-item index="专用册别">
                      <template slot="title">专用册别</template>
                    </el-menu-item>
                  </router-link>
                </el-submenu>
                <el-submenu index="章节管理">
                  <template slot="title">
                    <i class="el-icon-message"></i>
                    <span>章节管理</span>
                  </template>
                  <router-link :to="{name: 'sectionManageTbbk'}">
                    <el-menu-item index="同步备课">
                      <template slot="title">同步备课</template>
                    </el-menu-item>
                  </router-link>
                  <router-link :to="{name: 'sectionManageZkgk'}">
                    <el-menu-item index="中考高考">
                      <template slot="title">中考高考</template>
                    </el-menu-item>
                  </router-link>
                  <router-link :to="{name: 'sectionManageShijuan'}">
                    <el-menu-item index="试卷大全">
                      <template slot="title">试卷大全</template>
                    </el-menu-item>
                  </router-link>
                </el-submenu>

                <router-link :to="{name: 'knowledgeManage'}">
                  <el-menu-item index="知识点管理">
                    <template slot="title"><i class="el-icon-message"></i>知识点管理</template>
                  </el-menu-item>
                </router-link>

                <el-submenu index="试题管理">
                  <template slot="title">
                    <i class="el-icon-message"></i>
                    <span>试题管理</span>
                  </template>
                  <router-link :to="{name: 'examtypeManage'}">
                    <el-menu-item index="试题类型管理">
                      <template slot="title">试题类型管理</template>
                    </el-menu-item>
                  </router-link>
                  <router-link :to="{name: 'examhardManage'}">
                    <el-menu-item index="试题难度管理">
                      <template slot="title">试题难度管理</template>
                    </el-menu-item>
                  </router-link>
                </el-submenu>

                <el-submenu index="通用标签管理">
                  <template slot="title">
                    <i class="el-icon-message"></i>
                    <span>通用标签管理</span>
                  </template>
                  <router-link :to="{name: 'commonLevelOne'}">
                    <el-menu-item index="一级标签">
                      <template slot="title">一级标签</template>
                    </el-menu-item>
                  </router-link>
                  <router-link :to="{name: 'commonLevelTwo'}">
                    <el-menu-item index="二级标签">
                      <template slot="title">二级标签</template>
                    </el-menu-item>
                  </router-link>
                  <router-link :to="{name: 'commonLevelThree'}">
                    <el-menu-item index="三级标签">
                      <template slot="title">三级标签</template>
                    </el-menu-item>
                  </router-link>
                </el-submenu>


                <el-submenu index="试卷管理">
                  <template slot="title">
                    <i class="el-icon-message"></i>
                    <span>试卷管理</span>
                  </template>
                  <router-link :to="{name: 'shijuanTypeLink'}">
                    <el-menu-item index="栏目类型关联">
                      <template slot="title">栏目类型关联</template>
                    </el-menu-item>
                  </router-link>
                  <router-link :to="{name: 'shijuanTypeMap'}">
                    <el-menu-item index="新老类型映射">
                      <template slot="title">新老类型映射</template>
                    </el-menu-item>
                  </router-link>
                </el-submenu>
              </el-submenu>
            </el-menu>
          </el-scrollbar>
        </div>

      </el-aside>
      <el-container >
        <el-main  style="overflow-y: hidden;height:100%;background-color:#F3F5F8;">
          <div class="header-content">
            <!-- <div class="backfront" @click="backfront()">
              <span class="icon-my-back inlineblock"></span>
              <span>返回前台</span>
            </div> -->
            <div class="exit">
              <!-- <el-popover
                placement="bottom"
                width="200"
                trigger="click"
                v-model="visible">
                <div class="modifypassword" @click="updatePWD">修改密码</div>
                <span slot="reference">
                  <span>{{userinfo.username}} <i :class="{'el-icon-arrow-down':!visible,'el-icon-arrow-up':visible}"></i></span>
                </span>
              </el-popover> -->

              <el-popover
                placement="bottom"
                width="200"
                v-model="visible">
                <div class="modifypassword" @click="updatePWD">修改密码</div>
                <span slot="reference">
                  <span>{{userinfo.username}}<i :class="{'el-icon-arrow-down':!visible,'el-icon-arrow-up':visible}"></i></span>
                </span>
              </el-popover>

              <el-button type="danger" class="" @click="logout">退出</el-button> </div>
          </div>
          <div class="main_wrapper">
            <transition>
                <router-view></router-view>
            </transition>
          </div>
        </el-main>
        <!-- <el-footer height="40px" style="text-align: center;line-height: 40px;">{{copyRight}}</el-footer> -->
      </el-container>
    </el-container>
    <update-pwd-dialog v-model="updatePwdDialogVisible"  @success="editSuccess"></update-pwd-dialog>
  </div>
</template>
<script type="text/babel">
import {mapGetters, mapActions} from 'vuex'
import updatePwdDialog from './update-pwd'
import adminMixin from '@/mixins/adminMixin'

export default {
  mixins: [adminMixin],
  components: {
    updatePwdDialog: updatePwdDialog
  },
  data () {
    return {
      isvLeft: true,
      visible: false,
      updatePwdDialogVisible: false,
      copyRight: 'Copyright 2018-' + (new Date()).getFullYear() + ' 江西三端科技有限公司 版权所有'
    }
  },
  mounted () {
    if (this.userinfo && this.userinfo.authorities && this.userinfo.authorities) {
         for (let item of this.userinfo.authorities) {
          if (item.authority === 'API_MANAGE_DEVELOPER') {
            this.$router.push({name: 'devmanage'})
            break
          }
          else if (item.authority === 'API_MANAGE_STATISTICS') {
            this.$router.push({name: 'istatistics'})
            break
          }
          else if (item.authority === 'API_MANAGE_USER' && this.$route.name !== 'sysmanage') {
            // this.$router.push({name: 'sysmanage'})
            break
          }
          else if (item.authority === 'API_MANAGE_BASIC_DATA') {
            this.$router.push({name: 'learnManage'})
            break
          }
         }
    }
  },
  methods: {
    activeMenu () {
      if (this.userinfo && this.userinfo.authorities && this.userinfo.authorities) {
        let rights = []
        for (let item of this.userinfo.authorities) {
          rights.push(item.authority)
        }
        // 权限
        if (rights && rights.length > 0) {
          let _default = rights[0]
          this.defaultActive = this.defaultActives[_default]
        }
      }
      let menu = (this.$route.meta && this.$route.meta.menu || this.defaultActive)
      return menu
    },
    updatePWD () {
      this.updatePwdDialogVisible = true
      this.visible = false
    },
    editSuccess () {
      this.updatePwdDialogVisible = false
      this.$message.success(this.SysConstant.success)
    },
    // 返回前端
    backfront () {
      this.$router.push({name: 'frontIndex'})
    },
    logout () {
      this.$cookie.delete('token')
      this.$router.push({name: 'login'})
    }
  }
}
</script>
<style scoped>
  .admin-main-layout {
    width: 100%;
    min-height: 100vh;
  }
  .admin-main-layout  .el-container{
    width: 100%;
    min-height: 100vh;
  }
  .admin-main-layout .el-main{
    padding: 0px;
    margin: 0px;
  }
  .admin-main-layout .left-layout{
    background: #252c35;
    color: #ffffff;
    width: 240px;
    overflow: hidden;
  }
  .admin-main-layout .system-title{
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 18px;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    font-weight: bold;
    color: #fff;
    font-family: "微软雅黑";
    background-color: #0079B5;
  }
.admin-main-layout .header-content{
  height: 80px;
  background-color: #0591D7;
}
  .admin-main-layout .main_wrapper{
    background-color: #F3F5F8;
    height: calc(100vh - 82px);
    padding-left: 24px;
    overflow-y: auto;
  }
  .admin-main-layout .backfront{
    display: inline-block;
    margin-left: 20px;
  }
  .admin-main-layout .exit{
    display: inline-block;
    margin-right: 20px;
    float: right;
    color: #ffffff;
    line-height: 80px;
  }
  .admin-main-layout .exit span {
    color: #ffffff;
    margin-right: 15px;
    cursor: pointer;
  }
  .admin-main-layout .header-content .backfront {
    height: 40px;
    margin-left: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    line-height: 80px;
    cursor: pointer;
  }
  .admin-main-layout .header-content .backfront .inlineblock{
    display:inline-block ;
    height: 18px;
    width: 20px;
    margin-right: 16px;
  }
  .admin-main-layout .scrollbar-menu{
    height: calc(100% - 80px);
  }
</style>
<style type="text/css">
.admin-main-layout .scrollbar-menu .el-scrollbar__wrap {
  overflow-x: hidden;
}
.admin-main-layout .el-menu{
  background-color: #252C35;
}
.admin-main-layout .open-menu{
  border: none;
}

.admin-main-layout .open-menu a{
  color: #ffffff!important;
}
.admin-main-layout .open-menu a *{
  color: #ffffff!important;
}
.admin-main-layout .open-menu span{
  color: #ffffff!important;
}
.admin-main-layout .el-menu-item.is-active{
  color: #ffffff;
  background-color: #0591D7;
}
.admin-main-layout .open-menu a {
  color: #555;
  text-decoration: none;
}
.admin-main-layout  a:hover {
  text-decoration: none;
}
.admin-main-layout  .open-menu .el-menu-item.is-active a{
  color: #ffffff;
}
 .modifypassword{
    text-align: center;
    cursor: pointer;
   padding: 10px;
  }
 .modifypassword:hover{
  background-color: #00aaff;
   color: #ffffff;
}
.admin-main-layout .open-menu .el-submenu__title:hover,
.admin-main-layout .open-menu .el-menu-item:hover {
  outline: 0;
  background-color: #3f6c9e;
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/admin-layout/index.vue